import { render, staticRenderFns } from "./OrderShipping.vue?vue&type=template&id=1aa6eeea"
import script from "./OrderShipping.vue?vue&type=script&lang=js"
export * from "./OrderShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports